import { Outlet } from 'react-router-dom'
import { ROLES } from '@/constants/common'
import CustomerAdminLayout from './roles/customerAdmin/CustomerAdminLayout'
import DistributorAdminLayout from './roles/distributorAdmin/DistributorAdminLayout'
import DeliveryStaffLayout from './roles/deliveryStaff/DeliveryStaffLayout'
import SystemOwnerLayout from './roles/systemOwner/SystemOwnerLayout'
import { CustomerStaffLayout } from './roles/customerStaff/CustomerStaffLayout'
import LoadingOverlay from './base/LoadingOverlay'
import ScrollToTop from '../shared/ScrollToTop'
import { getCurrentRole } from '@/utils/auth'

const LayoutsByRole = {
  [ROLES.CUSTOMER_ADMIN]: CustomerAdminLayout,
  [ROLES.CUSTOMER_STAFF]: CustomerStaffLayout,
  [ROLES.DISTRIBUTOR_ADMIN]: DistributorAdminLayout,
  [ROLES.DELIVERY_STAFF]: DeliveryStaffLayout,
  [ROLES.SYSTEM]: SystemOwnerLayout
}

import NetworkStatusAlert from './base/NetworkStatusAlert'

export function MainLayout() {
  const role = getCurrentRole()
  const RoleLayout = LayoutsByRole[role] ?? DistributorAdminLayout

  return (
    <RoleLayout>
      <NetworkStatusAlert />
      <ScrollToTop />
      <Outlet />
      <LoadingOverlay />
    </RoleLayout>
  )
}
